import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { 
  HiOutlineDocumentText,
  HiOutlineVideoCamera,
  HiOutlineAcademicCap,
  HiOutlineSupport
} from 'react-icons/hi';

const ResourcesSection = () => {
  const { t, tArray } = useLanguage();
  
  const icons = [
    <HiOutlineDocumentText />,
    <HiOutlineVideoCamera />,
    <HiOutlineAcademicCap />,
    <HiOutlineSupport />
  ];
  
  const resourcesData = tArray('resources.items');
  const resources = resourcesData.map((resource, index) => ({
    icon: icons[index],
    title: resource.title,
    description: resource.description,
    linkText: resource.linkText,
    link: "#"
  }));

  return (
    <section id="resources" className="landing-section landing-section-light">
      <div className="container-landing">
        <div className="text-center">
          <h2 className="section-title">{t('resources.title')}</h2>
          <p className="section-subtitle">
            {t('resources.subtitle')}
          </p>
        </div>

        <div className="resources-grid">
          {resources.map((resource, index) => (
            <div key={index} className="resource-card" style={{ position: 'relative' }}>
              {/* Coming Soon Badge */}
              <div style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                backgroundColor: '#FFA500',
                color: 'white',
                padding: '5px 12px',
                borderRadius: '20px',
                fontSize: '0.75rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
              }}>
                {t('resources.comingSoon')}
              </div>
              <div className="resource-icon">
                {resource.icon}
              </div>
              <h3 className="resource-title">{resource.title}</h3>
              <p className="resource-description">{resource.description}</p>
              <a 
                href={resource.link} 
                className="resource-link"
                style={{ 
                  opacity: 0.5, 
                  cursor: 'not-allowed',
                  pointerEvents: 'none'
                }}
              >
                {resource.linkText} →
              </a>
            </div>
          ))}
        </div>

        <div className="text-center mt-4" style={{ marginTop: '4rem' }}>
          <div style={{ 
            backgroundColor: '#0E4774', 
            color: 'white', 
            padding: '3rem', 
            borderRadius: '8px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <h3 style={{ fontSize: '2rem', marginBottom: '1rem' }}>
              {t('resources.cta.title')}
            </h3>
            <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: 0.95 }}>
              {t('resources.cta.subtitle')}
            </p>
            <button 
              className="hero-btn-primary"
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  window.dispatchEvent(new CustomEvent('openContactForm'));
                }
              }}
              style={{ marginRight: '1rem' }}
            >
              {t('resources.cta.primaryButton')}
            </button>
            <button 
              className="hero-btn-secondary"
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  window.dispatchEvent(new CustomEvent('openContactForm'));
                }
              }}
            >
              {t('resources.cta.secondaryButton')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
